/* eslint-disable max-len */

import { SUPPORT_REFER_HELP_DESK } from "../errors/errorMessages"

// Tooltips for database search table headings
export const TT_SYS_REFERENCE = "Reference ID for each device"
export const TT_COMPLIANCE_STATUS =
    "Every device is assessed by ENA appointed evaluators against established technical and engineering standards."
export const TT_DATE_PUBLISHED = "Date the device was added into the database"
export const TT_MANUFACTURER = "Manufacturer of the device"
export const TT_CATEGORY = "Category the device belongs to "
export const TT_TYPE = "Type of device"
export const TT_REGISTERED_CAPACITY = "Registered capacity of the device"
export const TT_PHASE = "Number of phases required to connect the device"
export const TT_MODEL = "Model number of the device"
export const TT_VOLTAGE = "Voltage of the device"
export const TT_MAX_DEMAND = "Max demand of the device in amps per phase"

// DNO application search table headings
export const TT_APPLICATION_ID = "Unique application ID"
export const TT_POST_CODE = "Customer's post code"
export const TT_ADDRESS = "Line 1 of Customer's address"
export const TT_SUBMITTED = "Number of days ago application was submitted"
export const TT_CAPACITY =
    "The proposed new installed generation capacity of property in kilowatts. This value is only collected for applications with a generation component"
export const TT_DEMAND =
    "The proposed new total aggregate demand of property in amps. This value is collected for all applications. It is calculated by the installer"
export const TT_TECHNOLOGY = "The technology or technologies in the application"
export const TT_ACTIONS = "Click this column to respond to the application"
export const TT_INSTALLER = "The installer who submitted the application"
export const TT_AMEND =
    "You can amend the application after submission to make changes to non-crucial information"
export const TT_COMMISSIONING =
    "Generation applications require commissioning. When your application is ready for commissioning, you will see a button here allowing you to start the process"
export const TT_OUTCOME_DNO =
    "The status of the application. Applications on this page have all completed their journey through Connect Direct, meaning they have either been auto-approved by the platform or reviewed by someone from your connections team"
export const TT_STATUS_DNO =
    "The status of the application. You are required to carry out different actions depending on the status of the application. Hover over each status for more information"
export const TT_STATUS_INSTALLER =
    "The status of the application. However over each for more information"
export const TT_RAISED_BY =
    "The member of your organisation who raised the application"
// Tooltips for status pills
export const TT_APPROVED = "This device has been approved by Connect Direct"
export const TT_COMPLAINT = "This device is compliant with ENA standards"
export const TT_NON_COMPLIANT =
    "This device has been assessed as non-compliant with ENA standards"
export const TT_AWAITING_ASSESSMENT =
    "The platform is reviewing your application right now. Check back shortly to see the outcome!"
export const TT_READY_FOR_CX =
    "Once the installation is complete, this application requires commissioning. To start the commissioning process, go to the single application summary page"
export const TT_NON_COMPLIANT_NEW =
    "This device has been assessed as non-compliant for new installations"
export const TT_NON_COMPLIANT_MINOR =
    "This device has been assessed as minor non-compliant with ENA standards"
export const TT_COMPLAINT_CONFORMATION =
    "This device has been assessed as compliant but requires DNO conformation"
export const TT_AUTO_APPROVED =
    "This application has been auto-approved by Connect Direct. The assessment was conducted using DNO-provided thresholds"
export const TT_RE_AUTO_APPROVED =
    "This was application was resubmitted and has been auto-approved by Connect Direct. Installers are able to resubmit generation applications prior to commissioning in cases where the installation has changed versus the original approved application. The assessment was conducted using DNO-provided thresholds"
export const TT_DNO_APPROVED =
    "This application was escalated to the required DNO by Connect Direct. The DNO reviewed the application and approved it"
export const TT_DNO_APPROVED_WITH_LIMIT =
    "This application was escalated to the required DNO by Connect Direct. The DNO reviewed the application and approved it with a limit. You can see details on the limit on the application summary page"
export const TT_DNO_SERVICE_CABLE_REPLACEMENT_REQUIRED =
    "This application was escalated to the required DNO by Connect Direct. The DNO reviewed the application and determined that service cable replacement is required before the proposed devices can be connected"
export const TT_DNO_LOOPED_SERVICE_WORKS_REQUIRED =
    "This application was escalated to the required DNO by Connect Direct. The DNO reviewed the application and determined the property must be 'unlooped' before the proposed devices can be connected"
export const TT_DNO_FURTHER_INFO_REQUIRED =
    "This application was escalated to the required DNO by Connect Direct. The DNO reviewed the application and determined that further information is required before the proposed devices can be connected"
export const TT_ESCALATED_TO_DNO =
    "This application has been escalated to the required DNO by Connect Direct. The DNO is currently reviewing the application. No further installer action required at this time"
export const TT_RE_ESCALATED_TO_DNO =
    "This application was resubmitted and has been escalated to the required DNO by Connect Direct. Installers are able to resubmit generation applications prior to commissioning in cases where the installation has changed versus the original approved application. The DNO is currently reviewing the application. No further installer action required at this time"
export const TT_FAILED = `Something went wrong when processing this application. The application has failed and will not be processed further. Please ${SUPPORT_REFER_HELP_DESK}`
export const TT_FAILED_TOO_LARGE =
    "This application is too large to be processed by Connect Direct. It has failed and will not be processed further. It will not be sent to the DNO. Please complete the relevant G99 generation form and contact the DNO to get connected"
export const TT_IMAGE_SCANNING =
    "Connect Direct is currently scanning the cut-out image. Check back shortly to see the outcome!"
export const TT_IMAGE_SCAN_FAILED = `Connect Direct has failed to scan the cut-out image. The application has failed and will not be processed further. Please resubmit the application. Please ${SUPPORT_REFER_HELP_DESK}`
export const TT_INVALID_CUT_OUT = `The cut-out image you provided was assessed as invalid. This application will not be progressed further. Unfortunately, to progress this application, you are going to have to submit a new one with a different image. Please ensure the image is clear and taken from within 1 meter of the cut-out`
export const TT_CX_SUBMITTED =
    "Commissioning information has been submitted for the application and is ready for DNO review"
export const TT_CX_ACCEPTED =
    "Commissioning information has been accepted by the DNO. This means the commissioning process is now complete"
export const TT_CX_UPDATE_REQUIRED =
    "The DNO has requested an update to the commissioning information"
// Tooltips for async logic
export const TT_REVALIDATING =
    "Refreshing to ensure you have the latest data available to you!"

// Help Icons
export const TT_HELP_ESCALATED = `These applications have been escalated to you by Connect Direct
for further review. You can click into each application to get further details and information
as to why it was escalated. Please review each and submit a response`
export const TT_HELP_ALL_NOT_ESCALATED =
    "This page lists all resolved applications. An application is resolved if it has been assessed by Connect Direct and approved, or escalated to your team and subsequently responded to."
export const TT_HELP_INSTALLER_ADMIN_LIST_APPLICATIONS =
    "This page lists all applications submitted by your company. You can click into each application to get further details and information."
export const TT_HELP_INSTALLER_LIST_APPLICATIONS =
    "This page lists all applications you have submitted. You can click into each application to get further details and information."
export const TT_HELP_INSTALLER_DRAFT_APPLICATIONS =
    "This page lists all applications you have saved as draft. You can click on continue to complete the application"

// Tooltips for descriptions of recognised LCTs
export const TT_BATTERY =
    "Battery energy storage device (sometimes called BESS)"
export const TT_EVCP_DC = "Direct current electric vehicle charge point"
export const TT_EVCP_AC = "Alternating current electric vehicle charge point"
export const TT_V2G =
    "Electric vehicle charge point with vehicle to grid capability"
export const TT_SOLAR_PV = "Solar panel"
export const TT_SOLAR_PV_BATTERY = "Solar panel with a battery storage device"
export const TT_HP = "Heat pump"
export const TT_MULTIPLE_LCTS = "This application contains multiple LCTs"

// Tooltips for single application summary pages
export const TT_ENA_CHECK_PASS =
    "This check has passed. This means the device / property satisfied the DNO criteria for auto-approval"
export const TT_ENA_CHECK_FAIL = `This check has failed. This means the device / property did not satisfy the DNO criteria for auto-approval and therefore the application was escalated to the DNO for review`
export const TT_GO_TO_DEVICE_SUMMARY =
    "This device is registered on ENA's asset registers. Therefore, you can click here to see more details on it"

// Tooltips for icon buttons
export const TT_SIGN_OUT = "Click to sign out"
export const TT_TOTP = `Click to set up multi-factor-authentication (MFA).
This is required in order to get access to data on the portal`
export const TT_SETTINGS = "Click to access the user preferences panel"
export const TT_SIGN_IN = "Click to sign in / up"

// Tooltips for admins
export const TT_USER_MANAGE_PORTAL =
    "You are seeing this page as you are an admin for your company. This means you can manage all Connect Direct users within your company. This page allows you to: approve pending users, reject pending users, delete users, and change user permissions"
export const TT_APPROVE_USER_BUTTON =
    "Click to approve user. This will move them into your user pool and may grant them access to basic functionalities that is available to everybody in your user pool"
export const TT_REJECT_USER_BUTTON =
    "Click to reject and remove user. This will delete them and their account from Connect Direct"
export const TT_DELETE_USER_BUTTON =
    "Click to delete user. This will remove them from your user pool and delete their account from Connect Direct"
export const TT_REPORTING_SWITCH =
    "This functionality is currently under development, it will be available soon!"
export const TT_REVIWER_SWITCH =
    "This permission allows this users to view and respond to any applications in your organisation"
export const TT_ADMIN_SWITCH =
    "This permission gives the user admin rights for your organisation. This will allow them to administer other users on the platform and access technical API documentation"
export const TT_FALSE_MFA =
    "It is not possible to manage this user as they have not set up MFA. Please ask them to set up MFA"
export const TT_CX_SUBMIT =
    "Click here to go to begin the commissioning process for your application"
export const TT_AMEND_APPLICATION = "Click here to amend your application"
export const TT_ACTIVE_USERS =
    "Active users are users which you have already approved. You are able to assign permissions to these users via this tab. You can only see active users within your organisation"
export const TT_PENDING_USERS =
    "Pending users are users which have signed up to Connect Direct but are yet to be approved by you. You are seeing these users as they signed up with an email address belonging to your organisation. At present, they cannot see any protected Connect Direct data or perform any actions. You are able to approve or reject these users via this table. Only once approved will they become eligible for access to protected data and actions"
export const TT_DELETE_OWN_ACCOUNT = "You cannot delete your own account"

// Tooltips for KPI cards
export const TT_TOT_DEVICES =
    "The total number of devices proposed for installation. This does not include devices that are already installed"
export const TT_TOTAL_INSTALLED_GEN =
    "Total installed generation capacity of the property. This is calculated by Connect Direct by summing the registered capacity of all proposed and existing generation devices. It does not account for any export limiting devices (though these can be viewed on this page under 'Supply Details'). The value is in kilowatts and represents the total installed capacity across all phases. If the property has a mixture of single and three phase generators, the value used in the assessment assesses the worst case scenario where all single phase devices are placed on the same phase"
export const TT_TAD =
    "Total aggregate demand of the property including all proposed devices. This value is calculated by the installer and is in amps. This will always be less than the summed demand of all proposed and existing devices, unless an import limiting scheme is declared "
export const TT_EXISTING_DEVICES =
    "The number of LCT devices already installed on the property, excluding any import / export limiting devices"

/** *************************************
 * Tooltips for installer web portal
 ************************************* */
export const TT_ATTCH_UPLOAD_SUCCESS = "Attachment uploaded successfully"
export const TT_ATTCH_UPLOADING =
    "Attachment is being upload into the system. This may take a few seconds"
export const TT_ADDRESS_SEARCH =
    "Use this input to search for the address. You must search on address line 1. You cannot search on postcode. As you type, the form will suggest addresses. If you can't find the address you are looking for, you can manually enter the address. You can also overwrite any suggested address details"
export const TT_ADDRESS_SEARCH_MANUAL =
    "Use this input to manually enter the address. If the property has a name, enter using the format 'house name, town or borough' to maximise the chance of a successful MPAN lookup."
export const TT_ADDRESS_INPUT =
    "If entering manually, please enter the first line of the address"
export const TT_POSTCODE_INPUT =
    "If the address search produces the wrong postcode, you can overwrite it here"
export const TT_DEVICE_SEARCH =
    "Use this input to search for the device. As you type, it will suggest devices. You can search on device reference, model name, number or manufacturer. The search pulls data from the Connect Direct asset registers. If struggling to find your device, please check that it is registered on Connect Direct by 1) clicking 'Register Search' on the navigation bar and 2) searching for the device there"
export const TT_SELECT_LCT =
    "Select the type of LCT you are installing. Please note that for V2G applications, you must enter two devices on this section: one for the vehicle and one for the charger"
export const TT_MPAN =
    "Unique 13-digit reference that identifies each electricity supply point. Please only enter the 13 core digits required to uniquely identify a meter"
export const TT_MPRN =
    "Unique 11-digit reference that identifies each electricity supply point. Please only enter the 11 core digits required to uniquely identify a meter. This must start with 81"
export const TT_CANT_SEE_LCT =
    "Can't see the technology you are looking for in this list? You might have selected the wrong technology when you started the application. Click this button to jump back to the start. Unfortunately, you will have to start the application again if you choose this route"
export const TT_METER_NUMBER =
    "This input is only requested for applications in Northern Ireland. This is the meter number of the property"
export const TT_ENTER_MANUALLY =
    "If you can't find the device you are looking for in our registers, you can enter its details manually. If you take this option, you will be required to fill out a few more fields!"
export const TT_AMENDMENT_MODE_DISABLED =
    "Please note, you are not able to edit this field during an amendment. "
// Attachment download warnings
export const WARNING_MSG =
    "The downloaded file may contain confidential and/or privileged information. Any review, transmission, dissemination or other uses of this information by persons or entities other than the intended recipient is prohibited. Please download securely and delete immediately after use"

// TTR device publish
export const TT_DEVICE_REF =
    "This will be new the new unique reference for the device"
export const TT_MODEL_NUMBER = "The model number of the device"
export const TT_DEVICE_CAT = "The category to which device belongs"
export const TT_DEVICE_TYPE = "The type of generation device"
export const TT_REGISTERED_CAPACITY_TTR =
    "The registered capacity of the device in kilowatts. For multi-phase devices, this is the total capacity across all phases"
export const TT_DEVICE_PHASES = "The number of phases of the device"
export const TT_SOFTWARE_VERSION =
    "Please enter any details on the software / software versioning of the device"
export const TT_HARDWARE_VERSION =
    "Please enter any details on the hardware versioning of the device"
export const TT_LCT_TTR_DRAFT_CONTINUE =
    "If no longer required, please publish the draft and then delete it"

// Dashboard Homepages
export const TT_DEVICES_ALERT =
    "This table displays the last 20 devices that have had alerts raised. Alerts get raised when an issue is detected with a device. They can be raised by DNOs, the manufacturer of the device, evaluators and ENA. You can view the device details by clicking the individual row"
export const TT_DEVICES_REQUIRING_ATTENTION =
    "This table displays the last 20 devices that have been assessed as non-compliant. You can view the device details by clicking the individual row"
export const TT_DEVICES_AWAITING_ASSESSMENT =
    "This table displays the last 20 devices that are awaiting assessment. These devices have been submitted to Connect Direct and are currently being reviewed. You can view the device details by clicking the individual row"
export const TT_DEVICES_APPROVED =
    "This table displays the last 20 devices that have been approved. You can view the device details by clicking the individual row"

// EVDC core device form tooltips
export const TT_EVDC_MODEL_REF =
    "Please enter a unique reference Number for the model"
export const TT_EVDC_TYPE =
    "Please select the type of EVDC device. There are a fixed number of types to choose from"
export const TT_EVDC_MODULE = "The module of the EVDC device"
export const TT_EVDC_TOT_INPUT_RATED_CURRENT =
    "The total input rated current of the device in Amps per phase"
export const TT_EVDC_TOT_INPUT_RATED_POWER =
    "The total input rated power of the device in kW"
export const TT_EVDC_MAX_DEMAND_CURRENT =
    "The maximum demand current of the device in Amps per phase"
export const TT_EVDC_MAX_DEMAND_POWER =
    "The maximum demand power of the device in kW"
export const TT_EVDC_MODULE_INPUT_RATED_CURRENT =
    "The module input rated current in Amps per phase"
export const TT_EVDC_MODULE_INPUT_RATED_POWER =
    "The module input rated power in kW"
export const TT_EVDC_HARMONIC_TEST_STANDARDS =
    "Please select the harmonic test standard this device complies with"
export const TT_EVDC_COMMENTS_APP_TEST_STANDARDS_NOTES =
    "Enter any comments on testing standards"

// HP core device form tooltips
export const TT_HP_FUNCTION =
    "The function of the heat pump. Please select an option"
export const TT_HP_TYPE = "The type of heat pump. Please select an option"
export const TT_HP_PHASES = "Number of phases of the heat pump..."
export const TT_HP_VOLTAGE =
    "The voltage of the heat pump. Please select an option"
export const TT_HP_TOT_INPUT_RATED_CURRENT =
    "The total input rated current of the heat pump in amps per phase"
export const TT_HP_TOT_INPUT_RATED_POWER =
    "The total input rated power of the heat pump in kVA"
export const TT_HP_MAX_DEMAND_CURRENT =
    "The maximum current demand of the heat pump in amps per phase"
export const TT_HP_MAX_DEMAND_POWER =
    "The maximum current power of the heat pump in kVA"
export const TT_HP_PRODUCT_CODE =
    "The product code of the heat pump. This is typically its barcode or serial number"
export const TT_HP_HARMONIC_STANDARDS =
    "Please indicate which harmonic test standards the heat pump complies with. If none, please select 'N/A'"
export const TT_HP_FLICKER_STANDARDS =
    "Please indicate which flicker test standards the heat pump complies with"
export const TT_HP_MODULE =
    "Please select the option which best describes the overall system. For example, if the heat pump has a back-up heater onboard, select 'Heat pump+Back-up heater - on-board'. This answer should match the details provided in the 'Additional Components Associated with this Device' section"
export const TT_HP_MODULE_REF = "The module reference of the heat pump"
export const TT_HP_BACK_UP_HEATER_PRESENT =
    "If the heat pump has a back-up heater, please select 'Yes'"
export const TT_HP_BACK_UP_HEATER_PHASES =
    "Number of phases of back up heater..."
export const TT_HP_BACK_UP_HEATER_MODULE_REF =
    "The module reference of the back-up heater"
export const TT_HP_BACK_UP_HEATER_MODULE =
    "Please select the option that best describes the back-up heater module"
export const TT_HP_BACK_UP_HEATER_MODULE_INPUT_RATED_CURRENT =
    "The total input rated current of the back-up heater in amps per phase"
export const TT_HP_BACK_UP_HEATER_MODULE_INPUT_RATED_POWER =
    "The total input rated power of the back-up heater in kVA"
export const TT_HP_BOOST_HEATER_PRESENT =
    "If the heat pump has a boost heater, please select 'Yes'"
export const TT_HP_BOOST_HEATER_PHASES = "Number of phases of boost heater..."
export const TT_HP_BOOST_HEATER_MODULE_REF =
    "The module reference of the boost heater"
export const TT_HP_BOOST_HEATER_MODULE =
    "Please select the option that best describes the boost heater module"
export const TT_HP_BOOST_HEATER_MODULE_INPUT_RATED_CURRENT =
    "The total input rated current of the boost heater in amps per phase"
export const TT_HP_BOOST_HEATER_MODULE_INPUT_RATED_POWER =
    "The total input rated power of the boost heater in kVA"
export const TT_HP_WATER_HEATER_PRESENT =
    "If the heat pump has a water heater, please select 'Yes'"
export const TT_HP_WATER_HEATER_PHASES = "Number of phases of water heater..."
export const TT_HP_WATER_HEATER_MODULE_REF =
    "The module reference of the water heater"
export const TT_HP_WATER_HEATER_MODULE =
    "Please select the option that best describes the water heater module"
export const TT_HP_WATER_HEATER_MODULE_INPUT_RATED_CURRENT =
    "The total input rated current of the water heater in amps per phase"
export const TT_HP_WATER_HEATER_MODULE_INPUT_RATED_POWER =
    "The total input rated power of the water heater in kVA"
export const TT_HP_HEAT_PUMP_PRESENT =
    "If the heat pump has a back-up heat pump, please select 'Yes'"
export const TT_HP_HEAT_PUMP_PHASES =
    "Number of phases of the back-up heat pump..."
export const TT_HP_HEAT_PUMP_MODULE_REF =
    "The module reference of the heat pump"
export const TT_HP_HEAT_PUMP_MODULE =
    "Please select the option that best describes the back-up heat pump module"
export const TT_HP_HEAT_PUMP_MODULE_INPUT_RATED_CURRENT =
    "The total input rated current of the back-up heat pump in amps per phase"
export const TT_HP_HEAT_PUMP_MODULE_INPUT_RATED_POWER =
    "The total input rated power of the back-up heat pump in kVA"
export const TT_HP_NOM_CURRENT_W35 =
    "The nominal current of the device in amps per phase when the water temperature is 35 degrees celsius and the air temperature is 7 degrees celsius"
export const TT_HP_NOM_CURRENT_W45 =
    "The nominal current of the device in amps per phase when the water temperature is 45 degrees celsius and the air temperature is 7 degrees celsius"
export const TT_HP_NOM_CURRENT_W55 =
    "The nominal current of the device in amps per phase when the water temperature is 55 degrees celsius and the air temperature is 7 degrees celsius"
export const TT_HP_NOM_CURRENT_W65 =
    "The nominal current of the device in amps per phase when the water temperature is 65 degrees celsius and the air temperature is 7 degrees celsius"

/** *******************
 * EVAC
 ******************* */
export const TT_EVAC_MODEL_REF = "Model reference for the EV charger"
export const TT_EVAC_BARCODE =
    "Barcode number or product code for the EV charger"
export const TT_EVAC_MAX_CURRENT =
    "Maximum current the charger can draw in Amps per phase"
export const TT_EVAC_AC_ONLY = "Does the charger only output AC?"
export const TT_EVAC_V2G_CAPABILITY = "Does the charger have V2G capability?"

/** *******************
 * Commissioning
 ******************* */
export const TT_CX_LAUNCH =
    "Once the installation is complete, this application requires commissioning. Click here to start the commissioning process"

// Installer Draft Application
export const DRAFT_ID = "Unique draft ID"
export const TT_LAST_UPDATED =
    "Date when the draft application was last updated. You can sort by this column"
export const TT_COMPLETION_STATUS =
    "Percentage of the draft application that has been completed"
export const TT_REVIEW_SUBMIT =
    "Continue to review and submit the draft application"
export const TT_DELETE = "Delete the draft application"
export const TT_CONTINUE_BUTTON =
    "Click here to continue with the draft application"
export const TT_WARNING_DELETE_DRAFT =
    "This draft is 5 months old and will be deleted soon."
export const TT_DRAFT_POSTCODE =
    "Customer's post code. You can sort by this column."
export const TT_DRAFT_ID = "Unique draft ID. You can sort by this column."
